import { EditPaymentSchemaType } from './EditPayments-schema'

export enum EEditPaymentOperationKind {
  ManualEdits = 'ManualEdits',
  AddPayment = 'AddPayment',
  AddRecurringPayments = 'AddRecurringPayments',
  CatchUpAmountOfOverdueForDate = 'CatchUpAmountOfOverdueForDate',
  CatchUpOnRemainingPayments = 'CatchUpOnRemainingPayments',
  SpreadLateAmount = 'SpreadLateAmount',
  IncreasePayments = 'IncreasePayments',
  ReducePayments = 'ReducePayments',
  MovePayments = 'MovePayments',
  AddNoteToAllPayments = 'AddNoteToAllPayments',
  EnableSmsReminders = 'EnableSmsReminders',
  DisableSmsReminders = 'DisableSmsReminders',
  DeletePayment = 'DeletePayment',
  RestorePayment = 'RestorePayment',
  DeleteAllPayments = 'DeleteAllPayments',
}

export interface EditPaymentOperationCounts {
  changed: number
  added: number
  removed: number
}

export interface EditPaymentOperation {
  id: string
  kind: EEditPaymentOperationKind
  labelValues?: Record<string, string | number>
  counts: EditPaymentOperationCounts
}

const hasFieldChange = (before: EditPaymentSchemaType, after: EditPaymentSchemaType): boolean =>
  before.amount !== after.amount ||
  before.effectiveDate?.getTime() !== after.effectiveDate?.getTime() ||
  (before.note ?? '') !== (after.note ?? '') ||
  before.paymentMethod !== after.paymentMethod ||
  before.sendSmsReminder !== after.sendSmsReminder

export const countEditPaymentOperationEffect = (
  before: readonly EditPaymentSchemaType[],
  after: readonly EditPaymentSchemaType[],
): EditPaymentOperationCounts => {
  const beforeById = new Map(before.map((payment) => [payment.id, payment]))
  const afterIds = new Set(after.map((payment) => payment.id))

  let changed = 0
  let added = 0
  let removed = before.reduce((count, payment) => (afterIds.has(payment.id) ? count : count + 1), 0)

  after.forEach((payment) => {
    const previous = beforeById.get(payment.id)
    if (!previous) {
      added += 1
      return
    }
    if (payment.isDeleted && !previous.isDeleted) {
      removed += 1
      return
    }
    if (payment.isDeleted && previous.isDeleted) return
    if (previous.isDeleted !== payment.isDeleted || hasFieldChange(previous, payment)) changed += 1
  })

  return { changed, added, removed }
}

export const isEmptyOperationEffect = (counts: EditPaymentOperationCounts): boolean =>
  counts.changed === 0 && counts.added === 0 && counts.removed === 0
